import React from "react";

const PayoutControlList = React.lazy(() => import('src/pages/payout_control/PayoutControlList'));
const ViewPayoutControl = React.lazy(() => import('src/pages/payout_control/ViewPayoutControl'));

const routes = [
    { path: '/dashboard/payout-control-list/:param', withParam: true, exact: true, name: "", element: ViewPayoutControl },
    { path: '/dashboard/payout-control-list', name: 'Payouts', element: PayoutControlList },
];

export default routes;
